import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { useStore } from "../../../../app/stores/store";
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import MyTextInput from "../../../../app/common/form/MyTextInput";
import { CambiarCorreoyContraseñaFormValues, RecuperarUsuarioFormValues } from "../../../../app/models/RecuperarUsuario";
import { BsEyeSlash } from "react-icons/bs";

interface Props {
    userId: string;
}

export default observer(function ActualizarContraseña(props: Props) {
    const lowercaseRegex = /(?=.*[a-z])/;
    const uppercaseRegex = /(?=.*[A-Z])/;
    const numericRegex = /(?=.*[1-9])/;
    const caracterRegex = /(?=.*[@$!%*#?&%-/])/;
    const { PassStore, RecuperarUsuarioStore, SGPersonaStore, userStore, modalStore} = useStore();
    const { loading } = PassStore;
    const [passwordShown, setPasswordShown] = useState(false);
    const [passwordConfirmaShown, setPasswordConfirmaShown] = useState(false);

    const validationSchema1 = Yup.object({
        password: Yup.string()
            .min(8, "Se requieren al menos 8 caracteres, entre ellos, al menos una letra mayuscula, un número y un caracter especial")
            .matches(lowercaseRegex,
                "Debe incluir minusculas"
            )
            .matches(uppercaseRegex,
                "Debe incluir alguna mayuscula"
            )
            .matches(numericRegex,
                "Debe incluir algun numero"
            )
            .matches(caracterRegex,
                "Debe incluir algun caracter especial"
            )
            .required("La contraseña es obligatoria"),
            passwordConfirma: Yup.string().required("La confirmación es obligatoria")
            .oneOf([Yup.ref("password")], "Las Contraseñas no coinciden"),
    })

    function handleFormSubmit(credencialesIngresadas:any) {
        let newContraseña:any = {
            token: props.userId,
            email: "",
            password: credencialesIngresadas.password
        }

        RecuperarUsuarioStore.ActualizarContraseña(newContraseña).then(() => {
            if(RecuperarUsuarioStore.actualizoPassword == true){
                modalStore.closeModal()
                userStore.logout()
            }
        })
    }

    if (PassStore.loadingInitial) return <LoadingComponent content='Cargando...' />

    return (

        <div className="modal_pago_cur modal-reset-password">
            <div className="modal_pago_head">
                <h1>Actualizar contraseña</h1>
            </div>
            <Formik validationSchema={validationSchema1}
                enableReinitialize
                initialValues={{password:"", passwordConfirma:""}}
                onSubmit={values => {
                    handleFormSubmit(values)}
                    }>
                {({ handleSubmit, isValid, isSubmitting,errors, dirty }) => (
                    <Form onSubmit={handleSubmit} autoComplete='off' className="contenido_modal_pago">
                        <div className='login-form-content' style={{position:"relative"}}>
                            <p>Ingresa una nueva contraseña</p>
                            <MyTextInput name='password' placeholder='********' type={passwordShown ? "text" : "password"} />
                            <div className='showpassword-area'>
                                <a className='showPassword' style={{top: "63px", position: "absolute", height: "33.5px"}} onClick={() => setPasswordShown(!passwordShown)}> <BsEyeSlash /></a>
                            </div>
                            <p>Confirmar contraseña nueva</p>
                            <div className="CambiarUserPassConfirm">
                                <MyTextInput name='passwordConfirma' placeholder='********'type={passwordConfirmaShown ? "text" : "password"} />
                                <div className='showpassword-area'>
                                    <a className='showPassword' style={{top: "13.5px", position: "absolute", height: "33.5px"}}  onClick={() => setPasswordConfirmaShown(!passwordConfirmaShown)}> <BsEyeSlash /></a>
                                </div>
                            </div>
                        </div>
                        <div className="botones_pago_modal">
                            <Button
                                loading={loading}
                                type='submit'
                                content='Enviar'
                                className="primary"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>

    )
})
